import { ReactElement, useEffect } from 'react';
import { useFormikContext, Field } from 'formik';
import { iReviewFormValues } from '@services/ReviewService';
import { TileRadioAccessibleReview } from '@components';
import { tileReview } from '@interfaces/interfaces';
import gridStyles from '@pages/forms/Grid.module.scss';
import styles from './ReviewStep6.module.scss';
import PersonUnawareContent from './Grounds/PersonUnawareContent';
import ContraryToLaw from './Grounds/ContraryToLawContent';
import ExceptionalCircumstances from './Grounds/ExceptionalCircumstances';
import SpecialCircumstances from './Grounds/SpecialCircumstances';
import MistakeOfIdentity from './Grounds/MistakeOfIdentity';

function ReviewStep6(): ReactElement {
  const { values }: { values: iReviewFormValues } = useFormikContext();
  const context = useFormikContext();

  const reviewGrounds: tileReview[] = [
    {
      body: <ContraryToLaw />,
      subTitle: 'The fine was invalid or not properly issued to you',
      value: 'Contrary to law',
    },
    {
      body: <ExceptionalCircumstances />,
      subTitle: 'The offence occurred due to an extraordinary or unavoidable situation',
      value: 'Exceptional circumstances',
    },
    {
      body: <MistakeOfIdentity />,
      subTitle: 'The fine was issued to the wrong person',
      value: 'Mistake of identity',
    },
    {
      body: <PersonUnawareContent />,
      subTitle: 'You did not know about the fine',
      value: 'Person unaware',
    },
    {
      body: <SpecialCircumstances />,
      subTitle: 'You have serious personal issues, disorders or difficulties',
      value: 'Special circumstances',
    }
  ];
  const filteredGrounds = values.isDebtorTypeCompany ? reviewGrounds.filter((ground) => ground.value !== 'Special circumstances') : reviewGrounds;

  const selectGroundsTitle = <p>Please review the different grounds below carefully and select the one that best applies to your circumstances.</p>;

  useEffect(() => {
    if (!values.isPUEligible) {
      if (values.selectTheOption.includes('SelectedGroundInfo3')) {
        context.setFieldValue('selectTheOption', []);
        context.setFieldValue('SelectedObligationsStep11', []);
      }
    }
  }, [values.isPUEligible]);

  useEffect(() => {
    if (values.selectTheOption.length > 0) {
      context.setFieldTouched('selectTheOption', true);
    }
  }, []);

  return (
    <>
      <div className="vfH2">Why are you requesting a review?</div>
      <p>Under the law, review applications for this fine are only allowed under the grounds below.</p>
      <div>
        <div className={gridStyles.gridColFull}>
          <div className={styles.col}>
            <Field
              name="SelectedGroundInfo"
              component={TileRadioAccessibleReview}
              title={selectGroundsTitle}
              tileData={filteredGrounds}
              isPUIneligible={!values.isPUEligible}
              isMandatory
              orientationColumn
              validateFieldName="selectTheOption" />
            <br />
            <br />
          </div>
        </div>
      </div>
    </>
  );
}

export default ReviewStep6;
